import { Component, Input } from '@angular/core';
import { ButtonVariant, ButtonType } from './button.type';

@Component({
  selector: 'afp-button',
  templateUrl: './button.html',
  styleUrls: ['./button.scss']
})
export class ButtonComponent {
  @Input() type: ButtonType = 'button';

  @Input() disabled: boolean = false;

  @Input() variant: ButtonVariant = 'secondary';

  constructor() {}

  ngOnInit() {}
}
